/* global I18n */

import React, {useState} from "react"

const TermDescription = ({synonyms, show_all_synonyms}) => {
  const [is_hidden, set_is_hidden] = useState(!show_all_synonyms)

  const description =
    <>
      <strong>{I18n.t("js.synonyms")}</strong>
      {synonyms.length
        ? synonyms.slice(0, 2).join(", ")
        : <i>{I18n.t("js.none")}</i>
      }
    </>
  const hidden_synonyms = synonyms.slice(2)
  return (
    <div className="term-description">
      {description}
      {!!hidden_synonyms.length &&
        <>
          {", "}
          {is_hidden &&
            <a onClick={() => set_is_hidden(false)}>
              {I18n.t("js.show_more")}
            </a>}
          {!is_hidden && hidden_synonyms.join(", ")}
        </>}
    </div>
  )
}

export default TermDescription
